export default (value: string | null) => {
    if (typeof document === 'undefined') return null;
    const expires = `; expires=${new Date(
        Date.now() + 86400000 * 60 // Milliseconds, 60 days as recommended by Impact.
    ).toUTCString()}`;
    document.cookie =
        '_im_clickid' + '=' + (value || '') + expires + '; path=/';
};
